import MyPage from '../views/pages/userSettings/userSettingsView.vue';
import NavMenu from '../views/pages/Shared/NavMenu.vue';

export default [
    {
        name: 'user-settings',
        path: '/user-settings',
        components: {
            menu: NavMenu,
            default: MyPage,
        },
    },
];
